module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }